import {
  useCallback, useMemo
} from "react"
import classes from "./colorItem.module.css"

const ColorItem = (props) => {
  const {
    filterApi,
    filterState,
    group,
    item,
    onApply,
    onFilterItemMouseDown,
  } = props
  const {
    removeGroup, addItem 
  } = filterApi
  const {
    title, value, count 
  } = item

  const isSelected = filterState && filterState.has(item)

  // create and memoize an item that matches the tile interface
  const tileItem = useMemo(
    () => ({
      label: title,
      value_index: value,
    }),
    [title, value]
  )

  const handleClick = useCallback(
    (e) => {
      onFilterItemMouseDown()

      // use only left click for selection
      if (e.button !== 0) { return }

      removeGroup({
        group 
      })

      addItem({
        group, item 
      })

      if (typeof onApply === "function") {
        onApply(group, item)
      }
    },
    [group, item, removeGroup, addItem, onApply]
  )

  const {
    swatch_data, label 
  } = item || {}

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault()

        removeGroup({
          group 
        })

        addItem({
          group, item 
        })

        if (typeof onApply === "function") {
          onApply(group, item)
        }
      }
    },
    [group, item, onApply, removeGroup, addItem]
  )

  const blockClass = isSelected
    ? classes.colorFilterDefaultSelected
    : classes.colorFilterDefault

  const blockStyle = /^#\S+$/.test(swatch_data?.value)
    ? {
      backgroundColor: swatch_data?.value || "#fff",
    }
    : {
      backgroundImage:
                `url(${process?.env?.NEXT_PUBLIC_MAGENTO_BACKEND_URL}media/attribute/swatch/swatch_thumb/110x90${swatch_data?.value})` ||
                "#fff",
      backgroundRepeat: "no-repeat",
    }

  return (
    <span
      className={classes.root}
      onMouseDown={handleClick}
      onKeyDown={handleKeyDown}
    >
      <div className={blockClass} style={blockStyle} />
      <span className={classes.title}>{title}</span>
    </span>
  )
}

export default ColorItem
